import axios from "axios";
import router from "../../router/router.js";

const state={
    psClients:[],
    currentSaveState:"NotSaved"
};
const getters={
    allClients: (state)=>state.psClients,
    currentSaveState: (state)=>state.currentSaveState
};
const actions={  
    async fetchClients({commit}){
        axios.get(localConfig.authenticationURL + "/api/PsClient/All")
            .then((response) => {
                console.log(response.data);
                commit("setClients", response.data);               
            })
            .catch((error) => {
                localStorage.removeItem("token");
                console.log(error);
            });        
    },
    async updateClients({commit}) {
        console.log("All clients: " + state.psClients.length);

        state.psClients.forEach((client)=> {
            if(client.markedForDeletion == true)
            {
                axios.delete(localConfig.authenticationURL + "/api/PsClient/" + client.psClientGuid,client)
                    .then((response) => {
                        console.log("saved: " + JSON.stringify(response.data));     
                        window.Bus.$emit("updatedData", "updatedData");  
                    })
                    .catch((error) => {
                        localStorage.removeItem("token");
                        console.log(error);
                    }); 
                client.changed=false;

            }
            if(client.changed && client.created == undefined){
                commit("setCurrentSaveState","SavingData");

                client.psClientPasswordExpirationDays = parseInt("0" + client.psClientPasswordExpirationDays);
                client.psClientPasswordComplexityLength = parseInt("0" + client.psClientPasswordComplexityLength);
                client.psClientPasswordHistoryMinimum = parseInt("0" + client.psClientPasswordHistoryMinimum);   
                client.singleSignOnName = "" +  client.singleSignOnName;              
                
                axios.put(localConfig.authenticationURL + "/api/PsClient/",client)
                    .then((response) => {
                        console.log("saved: " + JSON.stringify(response.data));     
                        window.Bus.$emit("updatedData", "updatedData");  
                        alert("data was saved");
                    })
                    .catch((error) => {
                        localStorage.removeItem("token");
                        console.log(error);
                    }); 
                client.changed=false;
            }

            if(client.created == true)
            {
                commit("setCurrentSaveState","AddingData");

                client.psClientPasswordExpirationDays = parseInt("0" + client.psClientPasswordExpirationDays);
                client.psClientPasswordComplexityLength = parseInt("0" + client.psClientPasswordComplexityLength);
                client.psClientPasswordHistoryMinimum = parseInt("0" + client.psClientPasswordHistoryMinimum);   
                client.singleSignOnName = "" +  client.singleSignOnName;              

                axios.post(localConfig.authenticationURL + "/api/PsClient/",client)
                    .then((response) => {
                        console.log("saved new: " + JSON.stringify(response.data));      
                        alert("data was saved");
                        window.Bus.$emit("updatedData", response.data.psClientGuid);  
                    })
                    .catch((error) => {
                        localStorage.removeItem("token");
                        console.log(error);
                    }); 
                client.created=false;
            }       
        });
    }
};
const mutations={
    setClients: (state, psClients)=>(state.psClients = psClients),
    setCurrentSaveState: (state, currentSaveState)=>(state.currentSaveState = currentSaveState)
};

export default {
    state,
    getters,
    actions,
    mutations
};
